

(function () {
    window.seasonService = {
      get() {
        return axios.get(`/api/season/get.php`);
      },
      getAllSeason() {
        return axios.get(`/api/leaderboard/seasonal/get.php`);
      },
      save(data) {
        return axios.post('/api/season/save.php', data);
      },
      setSeason(data){
        return axios.post('/api/leaderboard/seasonal/save.php', {
          startDate: data.startDate,
          endDate: data.endDate
         });
      },
      getCurrent() {
        return axios.get('/api/season/current.php');
      }
    };
  })();
  